import { Breakpoints, styled } from '@volkswagen-onehub/components-core';

export const StyledFooterSelectionsGoTo = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${theme.size.static200};

    @media (min-width: ${Breakpoints.b960}px) {
      gap: ${theme.size.static350};

    }

  `
);
